function stripMarkdownToPlainText(input) {
  const source = String(input ?? '');
  return source
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]*`/g, ' ')
    .replace(/!\[[^\]]*]\([^)]+\)/g, ' ')
    .replace(/\[[^\]]+]\([^)]+\)/g, ' ')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/[>*_~\-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function estimateReadingMinutes(input = {}) {
  const locale = String(input.locale ?? 'zh');
  const plainText = stripMarkdownToPlainText(input.body ?? '');
  if (!plainText) {
    return 1;
  }

  if (locale === 'en') {
    const englishWords = plainText.split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(englishWords / 220));
  }

  const chineseChars = plainText.replace(/\s+/g, '').length;
  return Math.max(1, Math.ceil(chineseChars / 320));
}

function formatReadingTime(minutes, locale) {
  const safeMinutes = Math.max(1, Number(minutes) || 1);
  return locale === 'en' ? `${safeMinutes} min read` : `约 ${safeMinutes} 分钟阅读`;
}

export { estimateReadingMinutes, formatReadingTime };
